"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconForStudents = function IconForStudents(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M27.844 8.97H5.016l8.177 8.178-2.585 5.685.146.388.099.25a18.814 18.814 0 0 0 2.908 4.657c3.894 4.558 9.279 6.374 16.13 3.798l.388-.146 2.642-5.81H37v6.085a1.5 1.5 0 0 0-.588 2.448l-.995 6.467h4.166l-.995-6.467A1.5 1.5 0 0 0 38 32.056V25.97h6.844zm9.803 25.993a1.5 1.5 0 0 1-.294 0l-.77 5.007h1.833zM25.975 17.714l11.072 6.256h2.968L27.014 10.969H9.844L22.845 23.97h12.17l-9.517-5.377a1.5 1.5 0 1 1 .477-.879m4.749 8.256h-8.708l-7.312-7.312-1.923 4.228.092.201q.108.234.24.49l.136.262a17 17 0 0 0 2.032 2.99c3.248 3.802 7.55 5.359 13.208 3.473l.314-.109zm-6.686-8.699a.5.5 0 1 1 .91.414.5.5 0 0 1-.91-.414M38 33.47a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0",
    clipRule: "evenodd"
  })));
};

export { IconForStudents, IconForStudents as default };
